// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HI39","inner":"Footer_inner__1PPGj"};